import { render, staticRenderFns } from "./AddOtherDispatchesToCurrentInvoice.vue?vue&type=template&id=8ebac058&scoped=true&"
import script from "./AddOtherDispatchesToCurrentInvoice.vue?vue&type=script&lang=js&"
export * from "./AddOtherDispatchesToCurrentInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebac058",
  null
  
)

export default component.exports